const LABELS = {
  not_started: "Not started",
  assigned: "Not started",
  draft: "Draft saved",
  in_progress: "Draft saved",
  submitted: "Submitted",
  returned: "Returned for changes",
  graded: "Graded",
};

export const SubmissionStatusBadge = ({ status, testId = "submission-status" }) => {
  const tone = status === "graded" ? "bg-teal-50 text-teal-800 border-teal-200"
    : status === "submitted" ? "bg-sky-50 text-sky-800 border-sky-200"
    : status === "returned" ? "bg-amber-50 text-amber-900 border-amber-200"
    : "bg-slate-50 text-slate-700 border-slate-200";
  return <span data-testid={testId} className={`inline-flex px-2.5 py-1 rounded-full border text-xs font-semibold ${tone}`}>{LABELS[status] || status}</span>;
};